/**
 * Las columnas de la ficha que una credencial puede rellenar, con su nombre para personas.
 *
 * Vivían sólo en `RecursoForm.jsx` (donde se elige a qué columna va un recurso). La pantalla del
 * alta las necesita también —cada credencial dice A QUÉ CAMPO de la ficha va—, y copiarlas sería
 * una lista escrita a mano al lado de la que manda. Una sola lista, dos usos.
 */
export const CAMPOS_PERSONA = [
  { v: 'mail_empresa', label: 'Correo corporativo (mail_empresa)', nombre: 'Correo corporativo' },
  { v: 'telefono_empresa', label: 'Teléfono de empresa (telefono_empresa)', nombre: 'Teléfono de empresa' },
  { v: 'extension_telefono', label: 'Extensión (extension_telefono)', nombre: 'Extensión' },
  // Añadido en §4.8 junto con su ENUM. Es la columna de identidad con más cobertura real de
  // todas —232 personas la tienen rellena— y sin ella el NAS era invisible para las bajas.
  { v: 'usuario_nas', label: 'Usuario del NAS (usuario_nas)', nombre: 'Usuario del NAS' },
];

export const CAMPOS_PASSWORD = [
  { v: 'password_nas', label: 'Contraseña NAS' },
  { v: 'password_m365', label: 'Contraseña Microsoft 365' },
  { v: 'password_anydesk', label: 'Contraseña AnyDesk' },
  { v: 'password_admin_equipo', label: 'Contraseña de administrador del equipo' },
  { v: 'password_usuario_equipo', label: 'Contraseña de usuario del equipo' },
];

/** El nombre legible de una columna, o la propia columna si no está en la lista. */
export const nombreCampo = (v) => (CAMPOS_PERSONA.find((c) => c.v === v) || {}).nombre || v;
